module.exports = __webpack_public_path__ + "static/media/meep-logomarca.26519245.png";